// https://graphemica.com/
// https://emojidb.org/

export const icons = {
  "arrow-angle": "2304",
  "arrow-angle-double": "21e3",
  "arrow-chevron": "2357",
  "arrow-short": "2b07",
  "arrow-long": "ffec",
  "arrow-caret": "1f53b",
  "arrow-level": "21b4",
  "hand-pointer-o": "1f446",
  "hand-o": "1f447",
  "thumbs-o": "a002",
  "thumbs": "1f44e",
  "compress": "a003",
  "expand": "a004",
  "ellipsis": "22ee",
  "arrows-2-sides": "2195",
  "sort": "2b0d",
  "arrows-4-sides": "a005",
  "refresh": "1f504",
  "rotate-left": "27f2",
  "mail-reply": "21b6",
  "mail-reply-all": "a006",
  "check": "2714",
  "times": "2715",
  "plus": "2b",
  "minus": "2d",
  "external-link": "a010",
  "glass": "1f378",
  "music": "266b",
  "search": "1f50d",
  "envelope-o": "270",
  "heart": "2764",
  "star": "2b50",
  "star-o": "1f31f",
  "user": "1f464",
  "film": "1f39e",
  "th-large": "a011",
  "th": "a012",
  "th-list": "a013",
  "power-off": "1f4f4",
  "signal": "1f4f6",
  "cog": "2699",
  "trash-o": "1f5d1",
  "home": "1f3e0",
  "file-o": "1f4c4",
  "clock-o": "23f0",
  "road": "1f6e3",
  "download": "1f4e5",
  "inbox": "1f4e3",
  "list-alt": "a019",
  "lock": "1f512",
  "flag": "1f3f3",
  "headphones": "1f3a7",
  "volume-off": "1f508",
  "volume-down": "1f509",
  "volume-up": "1f50a",
  "qrcode": "a021",
  "barcode": "a022",
  "tag": "1f3f7",
  "tags": "a024",
  "book": "1f4d5",
  "bookmark": "1f516",
  "print": "1f5a8",
  "camera": "1f4f7",
  "font": "41",
  "bold": "42",
  "italic": "1d43c",
  "text-height": "a025",
  "text-width": "a026",
  "align-left": "a027",
  "align-center": "a028",
  "align-right": "a029",
  "align-justify": "a030",
  "list": "a031",
  "dedent": "a032",
  "indent": "a033",
  "video-camera": "1f3a5",
  "image": "1f5bc",
  "pencil": "270f",
  "map-marker": "1f4c3",
  "adjust": "a034",
  "tint": "1fa78",
  "edit": "1f4dd",
  "share-square-o": "a035",
  "play": "25b6",
  "pause": "23f8",
  "stop": "23f9",
  "forward": "23e9",
  "fast-forward": "23ed",
  "step-forward": "a037",
  "eject": "23cf",
  "crosshairs": "2629",
  "ban": "1f6ab",
  "asterisk": "2a",
  "gift": "1f381",
  "leaf": "1f343",
  "fire": "1f525",
  "eye": "1f441",
  "eye-slash": "1f648",
  "exclamation-triangle": "26a0",
  "plane": "2708",
  "calendar": "1f5d3",
  "random": "1f500",
  "comment": "1f4ac",
  "magnet": "1f9f2",
  "retweet": "a038",
  "shopping-cart": "1f6d2",
  "folder": "1f4c1",
  "folder-open": "1f4c2",
  "bar-chart": "1f4ca",
  "camera-retro": "a041",
  "key": "1f511",
  "cogs": "a042",
  "comments": "a043",
  "heart-o": "a045",
  "sign-out": "a046",
  "thumb-tack": "1f4cc",
  "sign-in": "a048",
  "trophy": "1f3c6",
  "lemon-o": "1f34b",
  "phone": "1f4de",
  "square-o": "a050",
  "bookmark-o": "a051",
  "twitter": "1f413",
  "facebook": "a053",
  "github": "1f431",
  "unlock": "a054",
  "credit-card": "1f4b3",
  "feed": "a055",
  "hdd-o": "a056",
  "bullhorn": "1f4e2",
  "bell-o": "a057",
  "certificate": "a058",
  "wrench": "1f527",
  "tasks": "a059",
  "filter": "a060",
  "briefcase": "1f4bc",
  "group": "1f465",
  "chain": "1f517",
  "cloud": "2601",
  "flask": "1f52c",
  "cut": "2702",
  "copy": "a062",
  "paperclip": "1f4ce",
  "floppy-o": "1f4be",
  "square": "f0c8",
  "bars": "2630",
  "list-ul": "a063",
  "list-ol": "a064",
  "strikethrough": "a065",
  "underline": "a066",
  "table": "a067",
  "magic": "1fa84",
  "truck": "1f69a",
  "pinterest": "a068",
  "money": "1f4b8",
  "columns": "a072",
  "envelope": "2709",
  "linkedin": "a074",
  "gavel": "1f528",
  "dashboard": "a075",
  "comment-o": "a076",
  "comments-o": "a077",
  "bolt": "26a1",
  "sitemap": "a078",
  "umbrella": "2602",
  "clipboard": "1f4cb",
  "lightbulb-o": "1f4a1",
  "exchange": "21c4",
  "user-md": "1f468",
  "stethoscope": "1fa7a",
  "suitcase": "a084",
  "bell": "1f514",
  "coffee": "2615",
  "cutlery": "1f374",
  "file-text-o": "a085",
  "building-o": "1f3e9",
  "hospital-o": "1f3e5",
  "ambulance": "1f691",
  "medkit": "1f48a",
  "fighter-jet": "a086",
  "beer": "1f37a",
  "desktop": "1f5a5",
  "laptop": "1f4bb",
  "tablet": "a088",
  "mobile": "1f4f1",
  "circle-o": "fc0",
  "quote-left": "a089",
  "quote-right": "a090",
  "spinner": "a091",
  "circle": "25cb",
  "github-alt": "1f408",
  "folder-o": "a093",
  "folder-open-o": "a094",
  "smile-o": "1f642",
  "frown-o": "1f641",
  "meh-o": "1f610",
  "gamepad": "1f579",
  "keyboard-o": "2328",
  "flag-o": "a095",
  "flag-checkered": "1f3c1",
  "terminal": "a096",
  "code": "a097",
  "star-half-empty": "a098",
  "location-arrow": "a099",
  "crop": "a100",
  "code-fork": "a101",
  "chain-broken": "a102",
  "question": "3f",
  "info": "2139",
  "exclamation": "2757",
  "superscript": "b2",
  "subscript": "2082",
  "eraser": "a107",
  "puzzle-piece": "1f9e9",
  "microphone": "1f3a4",
  "microphone-slash": "a109",
  "shield": "1f6e1",
  "calendar-o": "1f4c6",
  "fire-extinguisher": "1f9ef",
  "rocket": "1f680",
  "html5": "35",
  "css3": "33",
  "anchor": "2693",
  "unlock-alt": "1f513",
  "bullseye": "25ce",
  "ticket": "1f3ab",
  "compass": "1f9ed",
  "eur": "20ac",
  "gbp": "a3",
  "dollar": "24",
  "inr": "20b9",
  "cny": "a5",
  "rouble": "20bd",
  "krw": "20a9",
  "bitcoin": "20bf",
  "file": "a124",
  "file-text": "a125",
  "sort-alpha-asc": "a126",
  "sort-alpha-desc": "a127",
  "sort-amount-asc": "a128",
  "sort-amount-desc": "a129",
  "sort-numeric-asc": "a130",
  "sort-numeric-desc": "a131",
  "youtube-play": "a133",
  "dropbox": "a134",
  "stack-overflow": "a135",
  "instagram": "a136",
  "flickr": "a137",
  "bitbucket": "a139",
  "tumblr": "a140",
  "apple": "1f34e",
  "windows": "1fa9f",
  "android": "1f916",
  "linux": "1f427",
  "dribbble": "a142",
  "skype": "a143",
  "foursquare": "a144",
  "trello": "a145",
  "female": "1f6ba",
  "male": "1f6b9",
  "sun-o": "1f31e",
  "moon-o": "1f31d",
  "archive": "1f5c3",
  "bug": "1fab2",
  "vk": "f189",
  "dot-circle-o": "2609",
  "wheelchair": "267f",
  "try": "20ba",
  "space-shuttle": "1f47e",
  "slack": "f198",
  "bank": "1f3e6",
  "graduation-cap": "1f393",
  "google": "f1a0",
  "reddit": "f1a1",
  "language": "f1ab",
  "fax": "1f4e0",
  "building": "1f3e2",
  "child": "1f9d2",
  "paw": "1f43e",
  "spoon": "1f944",
  "cube": "1f4e6",
  "cubes": "f1b3",
  "behance": "f1b4",
  "steam": "f1b6",
  "recycle": "267b",
  "automobile": "1f698",
  "cab": "1f696",
  "tree": "1f332",
  "spotify": "f1bc",
  "deviantart": "f1bd",
  "soundcloud": "f1be",
  "database": "f1c0",
  "vine": "f1ca",
  "codepen": "f1cb",
  "jsfiddle": "f1cc",
  "life-bouy": "1f6df",
  "circle-o-notch": "f1ce",
  "wechat": "f1d7",
  "paper-plane": "f1d8",
  "history": "f1da",
  "circle-thin": "f1db",
  "header": "f1dc",
  "paragraph": "f1dd",
  "sliders": "f1de",
  "share-alt": "f1e0",
  "bomb": "f1e2",
  "futbol-o": "f1e3",
  "tty": "f1e4",
  "binoculars": "1f52d",
  "plug": "1f50c",
  "slideshare": "f1e7",
  "twitch": "f1e8",
  "yelp": "f1e9",
  "newspaper-o": "f1ea",
  "wifi": "f1eb",
  "calculator": "f1ec",
  "paypal": "f1ed",
  "google-wallet": "f1ee",
  "bell-slash": "1f515",
  "bell-slash-o": "f1f7",
  "trash": "f1f8",
  "copyright": "a9",
  "at": "40",
  "eyedropper": "f1fb",
  "paint-brush": "1f58c",
  "birthday-cake": "1f382",
  "area-chart": "1f4c9",
  "pie-chart": "1f967",
  "line-chart": "1f4c8",
  "lastfm": "f202",
  "toggle-off": "f204",
  "toggle-on": "f205",
  "bicycle": "1f6b2",
  "bus": "1f68d",
  "angellist": "f209",
  "cc": "f20a",
  "diamond": "1f48e",
  "ship": "26f5",
  "user-secret": "1f575",
  "motorcycle": "1f3cd",
  "street-view": "f21d",
  "heartbeat": "f21e",
  "venus": "2640",
  "mars": "2642",
  "mercury": "263f",
  "intersex": "26a5",
  "transgender-alt": "26a7",
  "venus-double": "26a2",
  "mars-double": "26a3",
  "venus-mars": "26a4",
  "mars-stroke": "26a6",
  "neuter": "26b2",
  "genderless": "26ac",
  "pinterest-p": "f231",
  "whatsapp": "f232",
  "server": "f233",
  "bed": "1f6cf",
  "train": "1f683",
  "subway": "1f686",
  "medium": "f23a",
  "battery": "1f50b",
  "battery-3": "1faac",
  "battery-2": "f242",
  "battery-1": "1faab",
  "battery-0": "f244",
  "mouse-pointer": "25e3",
  "i-cursor": "f246",
  "object-group": "f247",
  "object-ungroup": "f248",
  "sticky-note": "f249",
  "sticky-note-o": "f24a",
  "clone": "f24d",
  "balance-scale": "2696",
  "hourglass-2": "23f3",
  "hourglass-3": "231b",
  "hourglass": "23f",
  "trademark": "2122",
  "registered": "ae",
  "creative-commons": "33c4",
  "wikipedia-w": "57",
  "safari": "f267",
  "chrome": "f268",
  "firefox": "f269",
  "opera": "f26a",
  "internet-explorer": "f26b",
  "television": "1f4fa",
  "500px": "f26e",
  "amazon": "f270",
  "map-pin": "1f4cd",
  "map-signs": "1faa7",
  "map-o": "f278",
  "map": "1f5fa",
  "vimeo": "f27d",
  "fonticons": "f280",
  "reddit-alien": "f281",
  "edge": "f282",
  "credit-card-alt": "f283",
  "fort-awesome": "f286",
  "usb": "f287",
  "product-hunt": "f288",
  "mixcloud": "f289",
  "shopping-bag": "1f6cd",
  "shopping-basket": "1f9fa",
  "hashtag": "23",
  "bluetooth": "f293",
  "bluetooth-b": "f294",
  "percent": "25",
  "gitlab": "f296",
  "universal-access": "f29a",
  "wheelchair-alt": "1f9bc",
  "blind": "1f9af",
  "audio-description": "f29e",
  "volume-control-phone": "f2a0",
  "braille": "280b",
  "assistive-listening-systems": "1f9bb",
  "american-sign-language-interpreting": "f2a3",
  "deaf": "1f9cf",
  "glide-g": "f2a6",
  "sign-language": "f2a7",
  "low-vision": "f2a8",
  "snapchat-ghost": "f2ac",
  "first-order": "f2b0",
  "fa": "f2b4",
  "handshake-o": "1f91d",
  "envelope-open": "f2b6",
  "envelope-open-o": "f2b7",
  "address-book": "1f4d2",
  "address-book-o": "f2ba",
  "address-card": "f2bb",
  "address-card-o": "f2bc",
  "user-o": "f2c0",
  "id-badge": "f2c1",
  "drivers-license": "f2c2",
  "drivers-license-o": "f2c3",
  "free-code-camp": "f2c5",
  "telegram": "f2c6",
  "thermometer": "1f321",
  "shower": "1f6bf",
  "bath": "1f6c0",
  "podcast": "f2ce",
  "window-maximize": "f2d0",
  "window-minimize": "f2d1",
  "window-restore": "f2d2",
  "microchip": "f2db",
  "snowflake-o": "2744",
  "globe": "1f30e",
  "spirit": "1f984",
  "aguacatekun": "ff013",
  "avocado": "1f951",
  "nano": "4e",
};